<template>
  <div>
    <ConversaButton
      v-if="showConversaButton"
      :banner="true"
    />
    <div v-else>
      <StaticContent v-if="isConversa" data-cy="conversa" resource="conversa" />
      <StaticContent v-else data-cy="sin_conversa" resource="sin_conversa" />
    </div>
  </div>
</template>

<script>
import StaticContent from 'components/StaticContent.vue'
import ConversaButton from './ConversaButton.vue'

export default {
  name: 'conversa-banner-vue',
  components: { StaticContent, ConversaButton },
  props: {
    isConversa: { type: Boolean, default: false },
  },
  computed: {
    showConversaButton() {
      const allowedApps = ['tol', 'tph', 'tase', 'tnr']
      const currentApp = this.$current_app || gon.current_app
      return allowedApps.includes(currentApp) && this.isConversa
    }
  }
}
</script>
